import { render, staticRenderFns } from "./comment-outline.vue?vue&type=template&id=76e977b2&scoped=true&"
import script from "./comment-outline.vue?vue&type=script&lang=js&"
export * from "./comment-outline.vue?vue&type=script&lang=js&"
import style0 from "./comment-outline.vue?vue&type=style&index=0&id=76e977b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e977b2",
  null
  
)

export default component.exports